import {
  SITE_ADMIN_REMOVE_LISTING_START,
  SITE_ADMIN_REMOVE_LISTING_SUCCESS,
  SITE_ADMIN_REMOVE_LISTING_ERROR
} from '../../../constants';
import showToaster from '../../../helpers/showToaster';
import { getUpcomingBookingQuery , adminRemoveListing as mutation } from '../../../lib/graphql';

export function removeListing(listId, userRole) {
  return async (dispatch, getState, { client }) => {
    try {
      dispatch({
        type: SITE_ADMIN_REMOVE_LISTING_START,
      });

      let upcomingBookingCount;
      const bookedData = await client.query({
        query: getUpcomingBookingQuery,
        variables: {
          listId
        },
        fetchPolicy: 'network-only'
      });

      if (bookedData?.data?.getUpcomingBookings) {
        upcomingBookingCount = bookedData.data.getUpcomingBookings.count;
      }

      if (upcomingBookingCount > 0) {
        showToaster({ messageId: 'upcomingBooking', toasterType: 'error' })
      }
      else {
        // Send Request to get listing data
        const { data } = await client.mutate({
          mutation,
          variables: { listId },
        });

        if (data?.adminRemoveListing) {
          dispatch({
            type: SITE_ADMIN_REMOVE_LISTING_SUCCESS,
          });
          showToaster({ messageId: 'adminRemoveListing', toasterType: 'success' })

          if (data?.adminRemoveListing?.length > 0) {
            const removeFiles = await fetch('/removeMultiFiles', {
              method: 'post',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                files: data.adminRemoveListing,
              }),
              credentials: 'include',
            });
          }
        } else {
          dispatch({
            type: SITE_ADMIN_REMOVE_LISTING_ERROR,
          });
        }
      }
    } catch (error) {
      const errorText = [error?.message, ...(error?.graphQLErrors || []).map((e) => e?.message)].join(' ');
      if (errorText.includes('LISTING_HAS_THREADS')) {
        showToaster({ messageId: 'listingHasThreads', toasterType: 'error' });
      } else if (errorText.includes('LISTING_HAS_UPCOMING_BOOKINGS')) {
        showToaster({ messageId: 'upcomingBooking', toasterType: 'error' });
      } else if (errorText.includes('LISTING_HAS_RESERVATIONS')) {
        showToaster({ messageId: 'listingHasReservations', toasterType: 'error' });
      }
      dispatch({
        type: SITE_ADMIN_REMOVE_LISTING_ERROR,
        payload: {
          error
        }
      });
      return false;
    }
    return true;
  };
}
